import React, { useEffect, useState, useRef } from "react";
import Navbar from "../../../../posnavbar/Navbar";
import DownloadIcon from "@mui/icons-material/Download";
import { Box, Typography } from "@mui/material";
import LineGraph from "./LineGraph";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import Stack from "@mui/material/Stack";
import StyledButton from "../../../all-products/components/custom/StyledButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { PDFExport } from "@progress/kendo-react-pdf";

import "./index.css";
import CustomInternetSpeedMeter from "./customInternetSpeedMeter";

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff !important",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? "#2954A5" : "#2954A5",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color: theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

// ...existing code...

const NetworkConfig = () => {
  const navigate = useNavigate();
  const [checked, setChecked] = useState(localStorage.getItem("profilerSwitch") === "true");
  const [wifiSpeed, setWifiSpeed] = useState(
    JSON.parse(localStorage.getItem("internetData")) || []
  );
  const [currentSpeed, setCurrentSpeed] = useState(localStorage.getItem("currentSpeed") || "");

  const isProfilerOn = localStorage.getItem("profilerSwitch") === "true";

  const [responseCartTimes, setResponseCartTimes] = useState(() => {
    const data = localStorage.getItem("responseCartTimes");
    return data ? JSON.parse(data) : null;
  });

  const [addItemResponseTime, setAddItemResponseTime] = useState(() => {
    const data = localStorage.getItem("addItemResponseTime");
    return data ? JSON.parse(data) : [];
  });

  const [updateResponseCartTime, setUpdateResponseCartTime] = useState(() => {
    const data = localStorage.getItem("updateCartResponseTime");
    return data ? JSON.parse(data) : [];
  });

  const [responseGeneralCartTimes, setResponseGeneralCartTimes] = useState(() => {
    const data = localStorage.getItem("responseGeneralCartTimes");
    return data ? JSON.parse(data) : null;
  });

  const [responseAdvancedCartTimes, setResponseAdvancedCartTimes] = useState(() => {
    const data = localStorage.getItem("responseAdvancedCartTimes");
    return data ? JSON.parse(data) : null;
  });

  const ref = useRef(null);
  const allSpeedData = (speed) => {
    const newArr = wifiSpeed;
    newArr.push({ time: moment(new Date()).format("h:mmA"), speed: speed });
    if (localStorage.getItem("internetData")) {
      setWifiSpeed((prev) => [...prev, { time: moment(new Date()).format("h:mmA"), speed }]);
      localStorage.setItem("internetData", JSON.stringify(newArr));
      setCurrentSpeed(speed);
      localStorage.setItem("currentSpeed", speed);
    } else {
      setWifiSpeed(newArr);
      localStorage.setItem("internetData", JSON.stringify(newArr));
      setCurrentSpeed(speed);
      localStorage.setItem("currentSpeed", speed);
    }
  };

  // if (wifiSpeed?.length) {
  //   localStorage.setItem("internetData", JSON.stringify(wifiSpeed));
  // }
  // useEffect(() => {
  //   const internetData = JSON.parse(localStorage.getItem("internetData"));
  //   setWifiSpeed(internetData);
  // }, []);

  const internetData = {
    labels: wifiSpeed?.map((item) => item.time),
    datasets: [
      {
        color: "rgb(75, 192, 192)",
        borderColor: "#006000",
        // backgroundColor: "rgb(75, 192, 192)",
        data: wifiSpeed?.map((dataPoint) => [dataPoint?.time, dataPoint.speed]) || [],
      },
    ],
  };

  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? "pm" : "am";

    // Convert to 12-hour format
    hours = hours % 12 || 12;

    return `${hours}:${minutes < 10 ? "0" : ""}${minutes}${ampm}`;
  };

  const cartData = {
    labels: responseCartTimes?.map((data) => formatTime(data?.time)),
    datasets: [
      {
        color: "rgb(75, 192, 192)",
        borderColor: "#75E6DA",
        // backgroundColor: "rgb(75, 192, 192)",
        data: responseCartTimes?.map((data) => data?.responseTime) || [],
      },
    ],
  };

  const addCartItemData = {
    labels: addItemResponseTime?.map((data) => formatTime(data?.time)) || [],
    datasets: [
      {
        color: "rgb(75, 192, 192)",
        borderColor: "#2E8BC0",
        // backgroundColor: "rgb(75, 192, 192)",
        data: addItemResponseTime?.map((data) => data?.responseTime),
      },
    ],
  };

  const updateCartItemData = {
    labels: updateResponseCartTime?.map((data) => formatTime(data?.time)) || [],
    datasets: [
      {
        color: "rgb(75, 192, 192)",
        borderColor: "#2E8BC0",
        // backgroundColor: "rgb(75, 192, 192)",
        data: updateResponseCartTime?.map((data) => data?.responseTime),
      },
    ],
  };

  const generalCartData = {
    labels: responseGeneralCartTimes?.map((data) => formatTime(data?.time)) || [],
    datasets: [
      {
        color: "rgb(75, 192, 192)",
        borderColor: "#2E8BC0",
        // backgroundColor: "rgb(75, 192, 192)",
        data: responseGeneralCartTimes?.map((data) => data?.responseTime),
      },
    ],
  };

  const advancedCartData = {
    labels: responseAdvancedCartTimes?.map((data) => formatTime(data?.time)) || [],
    datasets: [
      {
        color: "rgb(75, 192, 192)",
        borderColor: "#2E8BC0",
        // backgroundColor: "rgb(75, 192, 192)",
        data: responseAdvancedCartTimes?.map((data) => data?.responseTime),
      },
    ],
  };

  const handleBack = () => {
    navigate("/products/operations-menu");
  };

  const handleClear = () => {
    const cartTime = localStorage.getItem("responseCartTimes");
    const addItemTime = localStorage.getItem("addItemResponseTime");
    const updateItemTime = localStorage.getItem("updateCartResponseTime");
    const generalCartTime = localStorage.getItem("responseGeneralCartTimes");
    const advancedCartTime = localStorage.getItem("responseAdvancedCartTimes");
    if (cartTime) {
      localStorage.removeItem("responseCartTimes");
      setResponseCartTimes([]);
    }
    if (addItemTime) {
      localStorage.removeItem("addItemResponseTime");
      setAddItemResponseTime([]);
    }
    if (updateItemTime) {
      localStorage.removeItem("updateCartResponseTime");
      setUpdateResponseCartTime([]);
    }
    if (generalCartTime) {
      localStorage.removeItem("responseGeneralCartTimes");
      setResponseGeneralCartTimes([]);
    }
    if (advancedCartTime) {
      localStorage.removeItem("responseAdvancedCartTimes");
      setResponseAdvancedCartTimes([]);
    }
    setWifiSpeed([]);
  };

  const handleSwitch = (event) => {
    localStorage.setItem("profilerSwitch", event.target.checked);
    setChecked(event.target.checked);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.shiftKey && event.key === "O") {
        setChecked((prevChecked) => !prevChecked);
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <>
      <Navbar>
        <Box className="network-config-main-container">
          <div className="pt-sticky-header">
            <div className="pt-header-content">
              <div className="pt-header-left">
                <button
                  type="button"
                  className="theme-back-button"
                  onClick={handleBack}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                  >
                    <path d="m12 19-7-7 7-7"></path>
                    <path d="M19 12H5"></path>
                  </svg>
                </button>
                <h1 className="pt-header-title">System Performance</h1>
              </div>
            </div>
          </div>

          <Box
            sx={{
              display: "flex",
              flex: 1,
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <FormGroup>
              <FormControlLabel
                className="switch-profile-btn-div"
                control={<IOSSwitch checked={checked} onChange={handleSwitch} />}
                label={checked ? "Profiler On" : "Profiler Off"}
                labelPlacement="start"
              />
            </FormGroup>

            <div className="network-config-btn-container">
              <StyledButton
                onClick={() => {
                  if (ref.current) {
                    ref.current.save();
                  }
                }}
                autoFocus
              >
                Download
                <DownloadIcon size="small" />
              </StyledButton>
              <StyledButton variant="secondary" color="red" onClick={handleClear}>
                Clear
              </StyledButton>
            </div>
          </Box>
          {/* <Box className="profiler-header-right">
            <FormGroup>
              <FormControlLabel
                className="internet-wrapper-text"
                control={<IOSSwitch checked={checked} onChange={handleSwitch} />}
                label={checked ? "Profiler On" : "Profiler Off"}
              />
            </FormGroup>
          </Box> */}
          <PDFExport paperSize="A3" scale={0.6} margin="0.5cm" ref={ref}>
            <Box
              sx={{
                marginTop: "1rem",
              }}
            >
              {checked && (
                <CustomInternetSpeedMeter
                  checked={checked}
                  pingInterval={3000}
                  thresholdUnit="megabyte"
                  threshold={8}
                  imageUrl="https://upload.wikimedia.org/wikipedia/commons/3/3f/Fronalpstock_big.jpg"
                  downloadSize={3100000}
                  callbackFunctionOnNetworkDown={(speed) =>
                    console.log(`Internet speed is down ${speed}`)
                  }
                  callbackFunctionOnNetworkTest={(speed) => allSpeedData(speed)}
                  txtMainHeading="Opps..."
                  txtSubHeading={`Internet speed is too slow`}
                  outputType="alert"
                />
              )}
              <h2 className="internet-wrapper-text">Internet Speed - {currentSpeed + " MB/s"}</h2>
              <div className="perf-graph-container">
                <LineGraph data={internetData} unit={"MB/s"} />
              </div>
            </Box>

            <Box className="network-cart-container">
              <Typography className="internet-wrapper-text">
                Cart Add Item Manual Response Time
              </Typography>
              <div className="perf-graph-container">
                <LineGraph data={cartData} unit={"ms"} />
              </div>
            </Box>
            <Box className="network-inventory-container">
              <Typography className="internet-wrapper-text">Cart Add Item Response Time</Typography>
              <div className="perf-graph-container">
                <LineGraph data={addCartItemData} unit={"ms"} />
              </div>
            </Box>
            <Box className="network-inventory-container">
              <Typography className="internet-wrapper-text">Update Cart Response Time</Typography>
              <div className="perf-graph-container">
                <LineGraph data={updateCartItemData} unit={"ms"} />
              </div>
            </Box>
          </PDFExport>
        </Box>
      </Navbar>
    </>
  );
};

export default NetworkConfig;
